module.exports = __webpack_public_path__ + "media/images/flags/it-2e1c877e1e803128b556b65ad2cb3b60.png";